import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Navbar from '../components/layout/Navbar';
import Icon from '../components/brand/Icon';
import './ContactPage.css';

const schema = Yup.object({
  name: Yup.string().required('Name is required'),
  email: Yup.string().email('Valid email required').required('Email is required'),
  businessName: Yup.string().required('Business name is required'),
  subject: Yup.string().required('Subject is required'),
  message: Yup.string().min(20, 'Message must be at least 20 characters').required('Message is required'),
});

const ContactPage = () => {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (values, { resetForm }) => {
    setError('');
    await new Promise(r => setTimeout(r, 800));
    setSubmitted(true);
    resetForm();
  };

  return (
    <div className="contact-page">
      <Navbar />
      <div className="contact-hero">
        <div className="container">
          <h1>Get in Touch</h1>
          <p>Have questions about RGV Smart Pay? We're here to help.</p>
        </div>
      </div>

      <div className="contact-content container">
        <div className="contact-grid">
          {/* Form */}
          <div className="card contact-form-card">
            {submitted ? (
              <div className="contact-success">
                <div className="success-icon"><Icon name="check" size={34} /></div>
                <h2>Message Sent</h2>
                <p>Thanks for reaching out. We'll get back to you within 1 business day.</p>
                <button className="btn btn-primary" onClick={() => setSubmitted(false)}>Send Another Message</button>
              </div>
            ) : (
              <>
                <h2>Send Us a Message</h2>
                {error && <div className="alert alert-error">{error}</div>}
                <Formik
                  initialValues={{ name: '', email: '', businessName: '', subject: 'General Inquiry', message: '' }}
                  validationSchema={schema}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting }) => (
                    <Form>
                      <div className="form-row">
                        <div className="form-group">
                          <label className="form-label">Your Name *</label>
                          <Field name="name" className="form-input" placeholder="Maria Garcia" />
                          <ErrorMessage name="name" component="div" className="form-error" />
                        </div>
                        <div className="form-group">
                          <label className="form-label">Email Address *</label>
                          <Field name="email" type="email" className="form-input" placeholder="maria@business.com" />
                          <ErrorMessage name="email" component="div" className="form-error" />
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Business Name *</label>
                        <Field name="businessName" className="form-input" placeholder="Maria's Flowers" />
                        <ErrorMessage name="businessName" component="div" className="form-error" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Subject *</label>
                        <Field as="select" name="subject" className="form-select">
                          <option>General Inquiry</option>
                          <option>Request a Walkthrough</option>
                          <option>Technical Support</option>
                          <option>Billing Question</option>
                          <option>Partnership</option>
                        </Field>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Message *</label>
                        <Field as="textarea" name="message" className="form-textarea" rows={5}
                          placeholder="Tell us about your business and how we can help..." />
                        <ErrorMessage name="message" component="div" className="form-error" />
                      </div>
                      <button type="submit" className="btn btn-primary btn-lg contact-submit" disabled={isSubmitting}>
                        {isSubmitting ? <><span className="spinner"></span> Sending...</> : 'Send Message'}
                      </button>
                    </Form>
                  )}
                </Formik>
              </>
            )}
          </div>

          {/* Info */}
          <div className="contact-info">
            <div className="card contact-info-card">
              <h3>Contact Information</h3>
              <div className="info-items">
                <div className="info-item">
                  <span><Icon name="pin" size={20} /></span>
                  <div>
                    <strong>Location</strong>
                    <p>Rio Grande Valley, Texas</p>
                  </div>
                </div>
                <div className="info-item">
                  <span><Icon name="mail" size={20} /></span>
                  <div>
                    <strong>Email</strong>
                    <p>support@rgvsmartpay.com</p>
                  </div>
                </div>
                <div className="info-item">
                  <span><Icon name="clock" size={20} /></span>
                  <div>
                    <strong>Response Time</strong>
                    <p>Within 1 business day</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="card contact-cta-card">
              <div className="cta-icon"><Icon name="building" size={26} /></div>
              <h3>Request a Walkthrough</h3>
              <p>Want to see RGV Smart Pay in action? We will walk you through everything personally.</p>
              <ul className="cta-list">
                <li><Icon name="check" size={15} /> Live walkthrough</li>
                <li><Icon name="check" size={15} /> Setup assistance</li>
                <li><Icon name="check" size={15} /> No pressure</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
